import { useCallback } from 'react'
import type { TGetUsersCursorQueryParams, TGetUsersQueryParams, TUsersCursorPage } from '../api/types/users'
import { CURSOR_LIST_PAGE_SIZE } from '../consts/api'
import { useWindowedCursorList } from './useWindowedCursorList'

type LoadUsersPage = (
  arg: TGetUsersCursorQueryParams,
  preferCacheValue?: boolean,
) => { unwrap: () => Promise<TUsersCursorPage> }

export function useUsersWindowedPage(
  resetKey: string | number,
  loadPage: LoadUsersPage,
  queryArgs: TGetUsersQueryParams,
) {
  const fetchPage = useCallback(
    async (cursor: string | null) => {
      const data = await loadPage({ ...queryArgs, cursor, limit: CURSOR_LIST_PAGE_SIZE }, true).unwrap()
      return {
        items: data.items ?? [],
        nextCursor: data.meta?.next_cursor ?? null,
      }
    },
    [loadPage, queryArgs],
  )

  return useWindowedCursorList({
    resetKey,
    fetchPage,
  })
}
